Model = require('models/Model').default
AppModel = require('models/AppModel')
AppLayout = require('views/AppLayout').default
Router = require('lib/Router').default

DataQualityReport = require('models/DataQualityReport').default
DataQualityReportModule = require('lib/dqr/DataQualityReportModule').default

ViewController = require('controllers/ViewController').default
MainController = require('controllers/MainController').default
MonitoringController = require('controllers/MonitoringController').default
RecordBrowserController = require('controllers/RecordBrowserController').default
DataEntryController = require 'controllers/DataEntryController'
HEXController = require('controllers/HEXController').default
SessionController = require('controllers/SessionController').default

# The application bootstrapper.
class Application extends Backbone.Marionette.Application

    __allow_initialization__: true

    constructor: () ->
        super()
        @initializationPromises = []

    addInitializationPromise: (promise) =>
        self = this
        @initializationPromises.push promise
            .then(
                (v) ->
                    v
                , (reason) ->
                    self.__allow_initialization__ = false # never initialize
                    unless promise instanceof Promise
                        console.log("INIT REJECT", reason || "[no reason given]")
                    throw reason
            )

    initialize: =>
        if ! @__allow_initialization__
            return

        self = this
        if @initializationPromises.length
            Promise.all(@initializationPromises).then ->
                self.initialize()
            @initializationPromises = []
            return # don't initialize yet

        # we're doing it; never again
        @__allow_initialization__ = false

        @model = new AppModel()

        @addInitializer((options) =>
            @model.set("hex", new Model({dateRange: null, participants: null}))
            @model.set("dataQualityReport", new DataQualityReport())
        )

        @on("initialize:after", (options) =>
            @mainController.dispatch("load:initialData")
        )

        @addInitializer((options) =>
            @layout = new AppLayout( appModel: @model)
        )

        @addInitializer((options) =>
            @viewController = new ViewController( model: @model, app: @ )
            @mainController = new MainController( model: @model, app: @ )
            @monitoringController = new MonitoringController( model: @model, app: @ )
            @hexController = new HEXController( model: @model.get("hex") )
            @recordBrowserController = new RecordBrowserController( model: @model, app: @ )

            # data entry methods should be stateless of a sort
            # there can be multiple of them so then need to recieve
            # the context for any action. Dont send data here.
            @dataEntryController = new DataEntryController()

            @DataQualityReportModule = new DataQualityReportModule(@)
        )

        @addInitializer((options) =>
            # Instantiate the router
            @router = new Router(@)
        )

        @addInitializer((options) =>
            @logoutController = new SessionController()
        )

        @addInitializer((options) =>
            el = $('body')

            PlatformDetect = require 'lib/PlatformDetect'
            platformDetect = new PlatformDetect()

            platformDetect.addPlatformClassesToElement el

            isMobile = platformDetect.isMobile()
            @reqres.addHandler "isMobile", ()->
                isMobile
        )

        @start()
        @

module.exports = new Application()



// WEBPACK FOOTER //
// ./app/application.coffee